const UidispatcherApiModule = await import("uidispatcher_api/UidispatcherApiModule");
export const CustomerCartMetaStore = UidispatcherApiModule.CustomerCartMetaStore;
